// extracted by mini-css-extract-plugin
export var icon = "Button-module--icon--4w6Kx";
export var inverted = "Button-module--inverted--y+1Ul";
export var root = "Button-module--root--a0Hzn";